import { combineReducers, configureStore } from '@reduxjs/toolkit';
import cancelledOrdersSlice from './cancelledOdersSlice';
import currentOrderReducer from './currentOrderSlice';
import errorSlice from './errorSlice';
import navigationReducer from './navigationSlice';
import newOrderReducer from './newOrderSlice';
import userdataReducer from './userdataSlice';

const rootReducer = combineReducers({
  navigationdata: navigationReducer,
  userdata: userdataReducer,
  newOrder: newOrderReducer,
  currentOrder: currentOrderReducer,
  errorState: errorSlice,
  cancelledOrders: cancelledOrdersSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
